import apiClient from 'helpers/api-client'
import { StateCreator } from 'zustand'
import { IBankAccount } from './interface'

export const createBankAccountSlice: StateCreator<IBankAccount> = (
  set,
) => ({
  // state
  isLoadingBankAccount: false,
  isSuccessBankAccount: false,
  bankAccount: {
    bank_name: '',
    account_name: '',
    account_no: '',
    bank: {
      bank_id: 0,
      bank_code: '',
      bank_name: '',
      min_withdraw: 0,
      max_withdraw: 0,
    },
  },
  responseError: {
    code: '',
    message: '',
    errors: [],
  },
  // actions
  getBankAccount: async () => {
    try {
      set({ isLoadingBankAccount: true })
      const res = await apiClient.get('/user/hub/v1/bank-account')
      if (res?.data?.code === 'SUCCESS') {
        set({
          bankAccount: res?.data?.data,
          isSuccessBankAccount: true,
        })
      }
      set({ isLoadingBankAccount: false })
    } catch (error) {
      set({ isLoadingBankAccount: false })
      console.error(error)
    }
  },
})
